var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-redux-form';
import { DragAndDropContainer } from "../../Layout/DragAndDrop";
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

import FormGroup from "../../DocumentForm/components/FormGroup";

import ThesauriFormField from "./ThesauriFormField";

export class ThesauriFormGroup extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.focus = () => {
      this.groupInput.focus();
    };
    this.renderItem = this.renderItem.bind(this);
    this.onChange = this.onChange.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
  }

  onChange(values) {
    const { index, onChange: onGroupChanged } = this.props;
    onGroupChanged(values, index);
  }

  removeGroup() {
    const { index, removeValue } = this.props;
    removeValue(index);
  }

  renderItem(item, index) {
    const { index: groupIndex } = this.props;
    return /*#__PURE__*/React.createElement(ThesauriFormField, _extends({}, this.props, { value: item, index: index, groupIndex: groupIndex }));
  }

  render() {
    const { value, index: groupIndex } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "group" }, `group-${groupIndex}`, /*#__PURE__*/
      _jsx(FormGroup, {}, void 0, /*#__PURE__*/
      _jsx(Field, { model: `thesauri.data.values[${groupIndex}].label` }, void 0, /*#__PURE__*/
      React.createElement("input", {
        ref: (i) => {
          this.groupInput = i;
        },
        className: "form-control",
        type: "text",
        placeholder: "Group name" }), /*#__PURE__*/

      _jsx("button", {
        tabIndex: groupIndex + 500,
        type: "button",
        className: "btn btn-xs btn-danger",
        onClick: this.removeGroup }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete Group")))), /*#__PURE__*/



      _jsx(DragAndDropContainer, {
        items: value.values,
        iconHandle: true,
        renderItem: this.renderItem,
        onChange: this.onChange })));



  }
}












export default ThesauriFormGroup;